import { useTranslation } from 'react-i18next';

export const useAccessSettingsForm = () => {
    const { t } = useTranslation();

    return { t };
};
